import React, { useRef } from 'react'
import { motion, useInView } from 'framer-motion';

export const Title = ({ title, titleNotes }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    return (
        <motion.h2
            ref={ref}
            className="mt-0 mb-0 text-center"
            style={{
              transform: isInView ? 'none' : 'translateX(-200px)',
              opacity: isInView ? 1 : 0,
              transition: 'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s',
            }}
        >
            {title}
            <span>{titleNotes}</span>
        </motion.h2>
    )
}